export default {
  getDraftPosts: (state) => state.draftPosts,
  getDataDraftPost: (state) => state.draftDataPost
}
